import { useMutate } from '@/shared/hooks/useMutate';
import { queryKeys } from '@/shared/api/queryKeys';
import { apiReportCreate } from '@/entities/reports/modules/api/reports';

export const useCreateReport = () =>
  useMutate({
    api: apiReportCreate,
    invalidateKeys: [queryKeys.reports.all, queryKeys.parcels.all],
  });
